import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/images/invite-member-sent.png'


const _hoisted_1 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "header-sub-title tw-mt-1 tw-flex tw-flex-col tw-gap-[.3rem]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "welcome__image !tw-mt-[30px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "modal__footer !tw-mt-4" }

import { TRADE_NETWORK } from "@/store/modules/trade-network";
import CommonDialog from "./CommonDialog.vue";
import { useStore } from "vuex";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InvitationSuccessComponent',
  props: {
  members: {
    type: Array,
    required: true,
  },
  isExternalTradeNetworkRequest: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const props = __props;

const emit = __emit;

const onClickCloseButton = (event: any) => {
  if (props.isExternalTradeNetworkRequest) {
    store.commit(`${TRADE_NETWORK}/setIsExternalTradeRequestSuccess`, true);
  }
  emit("onClose", true, event);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonDialog, {
      isShowHeader: false,
      isShowBackButton: false,
      width: "420px",
      "max-width": "100%",
      height: "auto",
      className: ['restricted__modal_box']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", {
          class: "dashboard-welcome__close !tw-top-8 !tw-right-8",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickCloseButton($event)))
        }, [
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            class: "!tw-text-[12px] tw-cursor-pointer",
            color: "#0C0F4A"
          })
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Text, {
            variant: "h4",
            textWeight: "400",
            lineHeight: "30px"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Your invitation has"),
              _hoisted_2,
              _createTextVNode(" been sent")
            ]),
            _: 1
          }),
          _createVNode(Text, {
            variant: "h6",
            textWeight: "400"
          }, {
            default: _withCtx(() => [
              _createTextVNode("We've sent your invitation to:")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.members, (member, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("b", null, _toDisplayString(member?.email), 1)
            ]))
          }), 128))
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Button, {
            label: "Back to trade network",
            variant: "accent",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickCloseButton($event)))
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})